import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Dumbbell, Target, Users, Award } from 'lucide-react';
import { Button } from '../components/ui/button';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Home = () => {
  useEffect(() => {
    AOS.init({
      duration: 600,
      easing: 'ease-in-out',
      once: true
    });
  }, []);

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <div className="container">
            <div className="hero-text" data-aos="fade-up">
              <h1 className="display-large">It's Time to Make the Change</h1>
              <p className="body-large">
                Elite competition experience meets personalized training. 
                Achieve your goals with a coach who understands your lifestyle.
              </p>
              <div className="hero-cta">
                <Link to="/contact">
                  <Button className="btn-cta">
                    Book Free Consultation
                    <ArrowRight className="ml-2" size={20} />
                  </Button>
                </Link>
                <Link to="/services">
                  <Button className="btn-services-hero">
                    View Services
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card" data-aos="zoom-in">
              <Award size={48} className="stat-icon" />
              <h3 className="heading-2">Elite Experience</h3>
              <p className="body-medium">Vancity Showdown Competitor & Marathon Trainer</p>
            </div>
            <div className="stat-card" data-aos="zoom-in" data-aos-delay="200">
              <Users size={48} className="stat-icon" />
              <h3 className="heading-2">Client-Focused</h3>
              <p className="body-medium">Specialized Programs for Busy Professionals</p>
            </div>
            <div className="stat-card" data-aos="zoom-in" data-aos-delay="400">
              <Target size={48} className="stat-icon" />
              <h3 className="heading-2">Results Driven</h3>
              <p className="body-medium">Proven Track Record of Client Transformations</p>
            </div>
          </div>
        </div>
      </section>

      {/* About Preview Section */}
      <section className="about-preview-section">
        <div className="container">
          <div className="about-preview-grid">
            <div className="about-preview-image" data-aos="fade-right">
              <img 
                src="https://customer-assets.emergentagent.com/job_451e4765-98e2-4958-85f3-3894bea3bc6f/artifacts/pdemmiyf_IMG_7583.jpeg" 
                alt="James Farina" 
              />
            </div>
            <div className="about-preview-content" data-aos="fade-left">
              <h2 className="heading-1">Meet James Farina</h2>
              <p className="body-large">
                With a background in elite bodybuilding competitions and marathon training, 
                I bring a unique perspective to personal training. I understand the mental 
                and physical challenges of transformation.
              </p>
              <p className="body-medium">
                My specialty is working with busy professionals who need scalable, 
                sustainable programs that fit their lifestyle. Whether you're looking to 
                lose weight, build muscle, or train for an event, I'm here to support you 
                every step of the way.
              </p>
              <Link to="/about">
                <Button className="btn-primary mt-4">
                  Read My Story
                  <ArrowRight className="ml-2" size={18} />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Services Preview */}
      <section className="services-preview-section">
        <div className="container">
          <div className="section-header" data-aos="fade-up">
            <h2 className="heading-1">Training Programs</h2>
            <p className="body-large">Tailored programs designed to help you achieve your fitness goals</p>
          </div>
          
          <div className="services-preview-grid">
            <div className="service-preview-card" data-aos="fade-up" data-aos-delay="100">
              <div className="service-image">
                <img src="https://images.unsplash.com/photo-1517836357463-d25dfeac3438" alt="Strength Training" />
              </div>
              <h3 className="heading-3">Strength & Conditioning</h3>
              <p className="body-medium">Build lean muscle and increase overall strength</p>
            </div>
            
            <div className="service-preview-card" data-aos="fade-up" data-aos-delay="200">
              <div className="service-image">
                <img src="https://images.pexels.com/photos/2204196/pexels-photo-2204196.jpeg" alt="Weight Loss" />
              </div>
              <h3 className="heading-3">Weight Loss Programs</h3>
              <p className="body-medium">Sustainable fat loss with personalized nutrition</p>
            </div>
            
            <div className="service-preview-card" data-aos="fade-up" data-aos-delay="300">
              <div className="service-image">
                <img src="https://images.unsplash.com/photo-1583454110551-21f2fa2afe61" alt="Bodybuilding" />
              </div>
              <h3 className="heading-3">Bodybuilding Prep</h3>
              <p className="body-medium">Competition-level training and coaching</p>
            </div>
          </div>
          
          <div className="text-center mt-8" data-aos="fade-up">
            <Link to="/services">
              <Button className="btn-primary">
                View All Services
                <ArrowRight className="ml-2" size={18} />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content" data-aos="fade-up">
            <h2 className="display-medium">Ready to Start Your Transformation?</h2>
            <p className="body-large">
              Book your free consultation today and discover how personalized training can help you achieve your goals.
            </p>
            <Link to="/contact">
              <Button className="btn-cta">
                Book Free Consultation
                <ArrowRight className="ml-2" size={20} />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
